import { SharedAngular } from '@Client/@types/sharedAngular';
import angular from 'angular';

angular
  .module('flowingly.runner.library')
  .controller('procedureDialogController', procedureDialogController);

procedureDialogController.$inject = ['$scope', 'procedureApiService'];

function procedureDialogController(
  $scope: IScopeNgDialog,
  procedureApiService: SharedAngular.ProcedureApiService
) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const ctrl = this;
  ctrl.procedureName = '';

  ctrl.startRecording = () => {
    ctrl.isRequestPending = true;
    return procedureApiService
      .createProcedure(ctrl.procedureName)
      .then((procedureId) => {
        $scope.closeThisDialog({ name: ctrl.procedureName, id: procedureId });
      })
      .catch(() => {
        ctrl.isRequestPending = false;
      });
  };

  ctrl.cancel = () => {
    $scope.closeThisDialog();
  };
}
